import * as _ from 'lodash';
import { User } from 'src/app/model/settings/user.model';
import { Partner } from 'src/app/model/settings/partner.model';
import { environment } from 'src/environments/environment';

declare const pendo: any;
export const initPendo = (user: User, partner: Partner) => {
    // only initialize Pendo for specific environments
    if (!environment.pendo) {
        return;
    }
    // if user or store is empty, don't initialize
    if (user.userId == null || user.userId === 0) {
        return;
    }
    // if no change in visitor or account; don't update visitor/account information
    if ((pendo.getVisitorId() === user.email) && (pendo.getAccountId() === partner?.id.toString())) {
        return;
    }

    try {
        if (partner?.id == null) {
          //initialize with account
          pendo.initialize({
            visitor: {
                id: user.email,
                email: user.email,
                firstName: user.first,
                lastName: user.last,
                access: user.access
            }
          });
        } else {
          pendo.initialize({
            visitor: {
                id: user.email,
                email: user.email,
                firstName: user.first,
                lastName: user.last,
                access: user.access
            },
            account: {
                id: `partner_${partner.id}`,
                name: partner.name,
                postalCode: partner.postal
            }
          });
        }

    } catch (e) {
        console.error('Pendo initialization failed. Exception thrown is:', e);
    }
};
export const updatePendo = (partner: Partner) => {
    // only update Pendo for specific environments
    if (!environment.pendo) {
        return;
    }

    // if partner is empty, don't update
    if ((partner?.id == null) || (pendo.getAccountId() === partner?.id.toString())) {
        return;
    }
    pendo.set_account_id(`partner_${partner.id}`);
    pendo.updateOptions({
        account: {
            name: partner.name,
            postalCode: partner.postal
        }
    });
};

export const clearPendoSession = () => {
  pendo.clearSession();
}

export const isPendoInitialized = () => {
  const visitorId: string = pendo.getVisitorId();
  if (visitorId == null ||
      _.isEmpty(visitorId) ||
      pendo.isAnonymousVisitor(visitorId)) {
    return false;
  }
  return true;
}
